export const auth = {
  authHomeTitle: 'Commençons',
  authHomeButtonBranded: 'Continuer avec E-mail',
  authHomeButtonApple: 'Continuer avec Apple',
  authHomeButtonGoogle: 'Continuer avec Google',
  authHomeButtonFacebook: 'Continuer avec Facebook',
  authHomeButtonLinkedin: 'Continuer avec LinkedIn',
  authStartTitle: 'Connexion ou Inscription',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Veuillez saisir une adresse e-mail valide!',
  authStartInputPasswordError: 'Veuillez saisir un mot de passe valide!',
  authWhoops: 'Oups!',
  authStartConfirmButton: 'Continuer',
  authRegisteredTitle: 'Bienvenue de retour!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Mot de passe',
  authRegisteredForgotPassword: 'Mot de passe oublié',
  authAlertIncorrectPassword: 'Votre e-mail ou votre mot de passe est incorrect',
  authAlertRequiredPassword: 'Veuillez saisir un mot de passe valide',
  authFinishSignUpTitle: "Terminer l'inscription",
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Prénom',
  authFinishSignUpLastNameInputTitle: 'Nom de famille',
  authFinishSignUpPasswordInputTitle: 'Mot de passe',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Nous vous recommandons d\'utiliser :</li><li class="list-disc">Au moins 8 caractères</li><li class="list-disc">Inclure 1 chiffre</li><li class="list-disc">Inclure 1 caractère spécial</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: "En cliquant sur S'inscrire, vous acceptez notre",
    privacyPolicy: 'Politique de confidentialité',
    text2: 'et',
    termsOfUse: "Conditions d'utilisation"
  },
  authFinishSignUpConfirmButton: "S'inscrire",
  authFinishSignUpErrorFirstName: 'Le prénom ne peut pas être vide!',
  authFinishSignUpErrorLastName: 'Le nom de famille ne peut pas être vide!',
  authFinishSignUpErrorPassword: 'Le mot de passe est trop court!',
  authEmailConfirmationTitle: 'Vérifiez votre boîte de réception',
  authEmailConfirmationContent:
    'Nous avons envoyé un e-mail de confirmation pour confirmer votre adresse e-mail. Veuillez également vérifier votre dossier spam si vous ne le trouvez pas dans votre boîte de réception.',
  authEmailConfirmationConfirmButton: 'Retour à la Connexion',
  authAlertEmailConfirmation: 'Veuillez vérifier votre boîte de réception pour confirmer votre e-mail!',
  authResetPasswordTitle: 'Vérifiez votre boîte de réception',
  authResetPasswordDescription:
    'Nous avons envoyé un lien de réinitialisation de mot de passe à votre adresse e-mail. Veuillez également vérifier votre dossier spam si vous ne le trouvez pas dans votre boîte de réception.',
  authResetPasswordButton: 'Retour à la connexion',
  authNewPasswordTitle: 'Saisir un nouveau mot de passe',
  authNewPasswordInputTitle: 'Nouveau mot de passe',
  authNewPasswordButton: 'Réinitialiser le mot de passe',
  authNewPasswordAlertValidation: "Votre mot de passe n'est pas assez fort",
  authPasswordChangeSuccessTitle: 'Mot de passe changé!',
  authPasswordChangeSuccessContent: 'Votre mot de passe a été changé avec succès!',
  authPasswordChangeSuccessButton: 'Retour à la connexion',
  authPasswordChangeErrorTitle: 'Erreur!',
  authPasswordChangeErrorContent:
    "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe! Réessayez plus tard.",
  authPasswordChangeErrorButton: 'Retour à la connexion',
  authInvitationTitle: 'Choisissez un mot de passe',
  authInvitationInputTitle: 'Mot de passe',
  authInvitationButton: 'Configurer le mot de passe',
  authEmailAddressConfirmed: 'Adresse e-mail confirmée!'
}
